/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListPendingEvaluationData } from './genericApiResponseListPendingEvaluationData';
import type { GenericApiResponseListPendingEvaluationMessage } from './genericApiResponseListPendingEvaluationMessage';
import type { GenericApiResponseListPendingEvaluationPagination } from './genericApiResponseListPendingEvaluationPagination';
import type { GenericApiResponseListPendingEvaluationError } from './genericApiResponseListPendingEvaluationError';

export interface GenericApiResponseListPendingEvaluation {
  data?: GenericApiResponseListPendingEvaluationData;
  message?: GenericApiResponseListPendingEvaluationMessage;
  pagination?: GenericApiResponseListPendingEvaluationPagination;
  error?: GenericApiResponseListPendingEvaluationError;
  statusCode?: number;
}
